import React, { useState, useEffect } from 'react';
import { ModalProcessingBlinder } from '../modal-helpers';
import Button from '../../buttons/DeprecatedButton/DeprecatedButton';
import { withRouter } from 'react-router-dom';
import { ModalInstanceProps } from '../interfaces';
import './GetStartedOnboardingModal.scss';
import { RouterComponentProps } from '../../helpers/routes/interfaces';
import monkeyImageWhite from 'assets/MobileMonkeyWhite.png';
import SelectorWithArrow from '../../../common/components/SelectorWithArrow/SelectorWithArrow';
import ChatbotModel from '@mm/state/model/ChatbotModel';
import { StoreState } from '@mm/state/store-interfaces';
import { Dispatch } from 'redux';
import SampleBotCRUDActions from '@mm/state/actions/SampleBotCRUDActions';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import {
  activeCompanySelector,
  sortedBotsSelector,
} from '@mm/state/selectors/viewSelectors';
import { AvailablePage } from '@mm/state/interfaces/connected-page';
import onboardingActions from '@mm/state/modules/onboardingState/actions';
import BasicModalTemplate from '../BasicModalTemplate';
import { AfterPageConnect } from '@mm/state/modules/modalsState/props';

type BotFromScratch = {
  id: number;
  name: string;
};

type OuterProps = {
  afterPageConnect: AfterPageConnect;
  onboarding: boolean;
  pageInfo: AvailablePage;
};

type InnerProps = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  ModalInstanceProps &
  RouterComponentProps;

type Props = InnerProps & OuterProps;

const BODY_TEXT = `
  Let's get started by customizing the very basics of your bot.
  You can start with picking the template for your first bot.
`;

export const botFromScratch = { id: -1, name: 'Start from scratch' };

const GetStartedOnboardingModalPure = (props: Props) => {
  const {
    closeModal,
    sampleBots,
    getSampleBots,
    afterPageConnect,
    onboarding,
    pageInfo,
    connectPage,
    company,
    isBusy,
  } = props;

  const [selectedTemplateBot, setSelectedTemplateBot] = useState<
    ChatbotModel | BotFromScratch
  >(botFromScratch);

  const [isProcessing, setIsProcessing] = useState(false);

  const templates = [botFromScratch, ...sampleBots];

  useEffect(() => {
    getSampleBots();
  }, []);

  if (isBusy || !company) {
    return null;
  }

  return (
    <BasicModalTemplate
      className="get-started-onboarding-modal"
      hideCloseButton={true}
    >
      <img
        src={monkeyImageWhite}
        alt="Customers.ai"
        className="get-started-onboarding-modal__logo"
      />

      <h2 className="get-started-onboarding-modal__header-text">
        Let's Get You Set Up!
      </h2>

      <div className="get-started-onboarding-modal__text">{BODY_TEXT}</div>

      <div className="get-started-onboarding-modal__selector-wrapper">
        <SelectorWithArrow
          className="get-started-onboarding-modal__selector"
          items={templates}
          selectedItem={selectedTemplateBot}
          onChange={id => {
            const template = templates.find(t => t.id === id);
            setSelectedTemplateBot(template || botFromScratch);
          }}
        />
      </div>

      <Button
        className="get-started-onboarding-modal__button"
        purple
        extraPadding
        invert
        onClick={async () => {
          setIsProcessing(true);

          const response = await connectPage(
            company.id,
            pageInfo,
            onboarding,
            selectedTemplateBot.id,
          );

          if (response && response.facebookPage) {
            await afterPageConnect(response);
          }

          setIsProcessing(false);
          closeModal();
        }}
      >
        Let's do this
      </Button>
      <ModalProcessingBlinder show={isProcessing} />
    </BasicModalTemplate>
  );
};

const mapStateToProps = (state: StoreState) => ({
  sampleBots: sortedBotsSelector(state),
  isBusy: state.sampleBots.busy,
  company: activeCompanySelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({
  getSampleBots: () => dispatch(SampleBotCRUDActions.retrieveAll()),
  connectPage: (
    companyId: number,
    pageInfo: AvailablePage,
    onboarding: boolean,
    templateBotId: number,
  ) =>
    dispatch(
      onboardingActions.connectPage(
        companyId,
        pageInfo,
        onboarding,
        templateBotId,
      ),
    ),
});

const enhance = compose<InnerProps, OuterProps>(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
);

export default enhance(GetStartedOnboardingModalPure);
